@use 'src/globals/main';

pn-pagination {
  display: block;
  margin-top: 1.5em;
}

pn-pagination .pn-pagination {
  display: flex;
  gap: 1em;
  flex-wrap: wrap;

  padding-top: 1em;
  border-top: 0.0625em solid main.$gray100;

  &-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5em;

    margin: 0 auto;
    &[data-right] {
      margin-right: 0;
    }

    > [data-arrow] {
      display: none;
      &[data-show] {
        display: inline-block;
      }
    }
  }

  &-rows {
    flex: 0 0 auto;
    margin-right: auto;
  }

  &-pages {
    flex: 0 0 auto;
    margin-left: auto;
  }

  &-list {
    list-style: none;
    padding: 0;
    margin: 0;

    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.5em;

    pn-button > .pn-button {
      padding: 0.375em 0.75em;
    }
  }

  &-dot {
    display: none;
    padding: 0.375em 0.5em;
    height: 2em;
    width: 2.5em;
    text-align: center;

    &[data-show] {
      display: inline-block;
    }
  }
}
